export default "__VITE_ASSET__BhrCUs2o__"